export default "__VITE_ASSET__wuWef9VF__"